<!-- =========================================================================================
  File Name: DataListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <password-view-sidebar :isSidebarActive="addPasswordSidebar" @closeSidebar="togglePassswordSidebar" :data="passwordSidebarData" />
    <data-view-sidebar :isSidebarActive="addNewDataSidebar"  @getdata="getdata"  @closeSidebar="toggleDataSidebar" :data="sidebarData" />
    <!-- ADD NEW -->
    <div >
      <!-- <vs-button class="user_add_btn" radius icon="icon-plus" icon-pack="feather"    @click="addNewData"/> -->
    <vs-button class="user_add_btn" type="filled" @click.native="addNewData"><feather-icon icon="PlusIcon" class="flex-inline" svgClasses="h-3 w-3" /> {{ $t('teacher.add_btn') }}</vs-button>
    </div>
    <vs-table ref="table" :data="filteredTeacherList" :max-items="itemsPerPage"  pagination
              search>

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ACTION - DROPDOWN -->
          <vs-dropdown v-if="selected.length>0" vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">Actions ({{selected.length}})</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

           <vs-dropdown-menu>
               <vs-dropdown-item @click="selectAction('status')">
                <span class="flex items-center"  >
                  <feather-icon icon="ToggleRightIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Enable</span>
                </span>
              </vs-dropdown-item>
               <vs-dropdown-item  @click="selectAction('disablestatus')">
                <span class="flex items-center" >
                  <feather-icon icon="ToggleLeftIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Disabled</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item  @click="selectAction('deleteuser')">
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

<!--           FILTER-->
         <vx-tooltip v-if="locations.length>0" text="Search By Location" position="top">
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2" v-html="custom_search_filter">Search By Location</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="setSelected('Search By Location')">
                <span class="flex items-center">
                  <span  >All</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item v-for="location in locations" :key="location.id" @click="setSelected(location.name)">
                <span class="flex items-center">
                  <span >{{ location.name }}</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>
          </vx-tooltip>
              <vx-tooltip text="Search By Status" position="top">
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2" v-html="custom_search_filter_status">Search By Status</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="statusSelected('Search By Status')">
                <span class="flex items-center">
                  <span>All</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item v-for="status in statuses" :key="status.id" @click="statusSelected(status.name)">
                <span class="flex items-center">
                  <span >{{ status.name }}</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>
          </vx-tooltip>
          <!-- ADD NEW -->
<!--          <div-->
<!--            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"-->
<!--            @click="addNewData">-->
<!--            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>-->
<!--            <span class="ml-2 text-base text-primary">Add New</span>-->
<!--          </div>-->
        </div>


        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{
                currentPage * itemsPerPage - (itemsPerPage - 1)
              }} - {{ teachers.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : teachers.length }} of {{
                queriedManager
              }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="setitemsPerPage(25)">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="setitemsPerPage(50)">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item  @click="setitemsPerPage(75)">
              <span>75</span>
            </vs-dropdown-item>
             <vs-dropdown-item @click="setitemsPerPage(100)">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-checkbox v-model="headCheckbox" @input="CheckAll()"></vs-checkbox>
        <vs-th sort-key="name">Image</vs-th>
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="programs">Programs</vs-th>
        <vs-th sort-key="locations">Locations</vs-th>
        <!-- <vs-th sort-key="status">Email Confirmed</vs-th> -->
        <vs-th sort-key="status">Status</vs-th>

        <vs-th>Action</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
            <vs-td><vs-checkbox  @input="SelectItem(tr.id)" v-model="selectedCheck[indextr]"></vs-checkbox></vs-td>
              <vs-td class="img-container">
                <img v-if="tr.avatar"  :src="img_cdn + tr.avatar"   class="rounded-full coverimg shadow-md user-img" />
                <p v-else class="bg-primary image-not-found text-white" :data-letterstudent="tr.fname[0].toUpperCase()"></p>
              </vs-td>
              <vs-td>
                <vs-td>
                <p class="product-name font-small text-sm truncate">{{ tr.fname }} {{ tr.middle_name }} {{ tr.lname }} </p>
                <p class="product-name font-small text-sm truncate"><a :href="`tel:${tr.phone}`" @click.stop="">{{ tr.phone }}</a></p>
                <p class="product-name font-small text-sm truncate"><a :href="`mailto:${tr.email}`" @click.stop="">{{ tr.email | valid_email }}</a></p>
              </vs-td>

              </vs-td>
               <vs-td>
              <ul><li v-for="program in tr.programs" style="display: flex" :key="program.id"><vs-chip >{{ program.name }}</vs-chip></li></ul>

              </vs-td>

              <vs-td>
              <ul><li v-for="location in tr.locations" style="display: flex" :key="location.id"><vs-chip >{{ location.name }}</vs-chip></li></ul>

              </vs-td>

              <!-- <vs-td>
                <vs-switch  v-model="tr.email_confirmed" @input="updateEmailStatus(tr.id,tr.email_confirmed)"></vs-switch>
              </vs-td> -->

              <vs-td>
                <vs-switch v-model="tr.status"  @input="updateStatus(tr.id,tr.status)"></vs-switch>
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <!-- ACTION - DROPDOWN -->
                <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer">
                <div>
                    <feather-icon icon="MoreVerticalIcon" @click.stop="" svgClasses="w-6 h-6 hover:text-primary stroke-current" class="ml-2" />
                </div>
                 <vs-dropdown-menu>
                 <vs-dropdown-item @click="editData(tr)">
                <span class="flex items-center" >
                  <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span> Edit </span>
                </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="confirmDeleteRecord(tr)">
                <span class="flex items-center" >
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2 "/>
                  <span>Delete</span>
                </span>
                </vs-dropdown-item>
                <vs-dropdown-item  @click="passwordData(tr)">
                <span class="flex items-center">
                  <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Password Reset</span>
                </span>
                  </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
                <!--                <feather-icon icon="EditIcon" svgClasses="w-6 h-6 hover:text-primary stroke-current" @click.stop="editData(tr)" />-->
                <!--                <feather-icon icon="TrashIcon" svgClasses="w-6 h-6 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" />-->
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
  </div>
</template>

<script>
import DataViewSidebar from './DataViewSidebar.vue'
import vSelect from 'vue-select'
import PasswordViewSidebar from './PasswordViewSidebar'

import {
  ALL_LOCATIONS,
  ALL_TEACHERS_QUERY,
  REMOVE_MANAGER,
  UPDATE_MANAGER_EMAIL_STATUS,
  UPDATE_USER_STATUS
} from '@/graphql'


export default {
  components: {
    DataViewSidebar,
    PasswordViewSidebar,
    'v-select': vSelect

  },
  data () {
    return {
      img_cdn:process.env.VUE_APP_AWS_s3Url+"/",
      headCheckbox:'',
      selectedCheck:[],
      teachers:[],
      locations:[],
      custom_search_filter:'Search By Location',
      custom_search_filter_status:'Search By Status',
      statuses:[
        {
          id:'1',
          name:'Active'
        },
        {
          id:'2',
          name:'Disabled'
        },
        {
          id:'3',
          name:'Pending'
        }
      ],
      selected: [],
      itemsPerPage: 10,
      isMounted: false,
      // Data Sidebar
      addNewDataSidebar: false,
      addPasswordSidebar:false,
      sidebarData: {},
      passwordSidebarData:{},
      DeletedItem:''
    }
  },
  computed: {

    filteredTeacherList () {
      const custom_search_filter_status = this.custom_search_filter_status
      const custom_search_filter = this.custom_search_filter
      return this.teachers.filter(function (teacher) {
        if (custom_search_filter_status != 'Search By Status' && custom_search_filter == 'Search By Location') {
          if (custom_search_filter_status == 'Active') {
            if (teacher.email_confirmed && teacher.status) {
              return true
            }
            return false
          }
          if (custom_search_filter_status == 'Disabled') {
            if (teacher.email_confirmed == false && teacher.status == false) {
              return true
            }
            return false
          }
          if (custom_search_filter_status == 'Pending') {
            if (teacher.email_confirmed == false && teacher.status == true) {
              return true
            }
            return false
          }
        }
        if (custom_search_filter == 'Search By Location') {
          return true
        }
        if (custom_search_filter !== 'Search By Location') {
          for (let i = 0; i < teacher.locations.length; i++) {
            if (teacher.locations[i].name == custom_search_filter) {
              return true
            }
          }
          return false
        }
        return true
      })
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.teachers.length
    },
    queriedManager () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.teachers.length
    }
  },
  methods: {
    getdata (value) {
      if (value) {
        this.getTeacherList()
      }
    }, 
    ConfirmNotification (status) {
      this.$vs.notify({
        title: 'Teacher',
        text: `Teacher ${status} Successfully`,
        color: 'success',
        position: 'top-right'
      })
    },
    StatusSuccess (status, color) {
      this.$vs.notify({
        title: 'Teacher',
        text: status,
        color,
        position: 'top-right'
      })
    },
    selectAction (action) {
      if (this.selected.length > 0) {
        this.$apollo
          .mutate({
            mutation: USER_EMAIL_CONFIRMED,
            variables: {
              name: action,
              user_ids: this.selected
            }
          }).then(response => {
            if (response) {
              this.ConfirmNotification(response.data.confirmUserEmail.status)
              this.selected = []
              this.headCheckbox = false
              for (let index = 0; index < this.selectedCheck.length; index++) {
                this.selectedCheck[index] = false
              }
              this.getTeacherList()
            }
          }).catch(error => {

          })
      }
    },
    CheckAll () {
      const selected = []
      if (this.headCheckbox) {
        for (let index = 0; index < this.teachers.length; index++) {
          this.selectedCheck[index] = true
          selected.push(this.teachers[index].id)
        }
        this.selected = selected
      } else {
        for (let index = 0; index < this.teachers.length; index++) {
          this.selectedCheck[index] = false
        }
        this.selected = []
      }
    },
    SelectItem (id) {
      if (!this.headCheckbox) {
        let status = false
        for (let i = 0; i < this.selected.length; i++) {
          if (this.selected[i] == id) {
            status = true
          }
        }
        if (status) {
          for (let i = 0; i < this.selected.length; i++) { 
            if (this.selected[i] === id) { 
              this.selected.splice(i, 1) 
            }
          }
        } else {
          this.selected.push(id)
        }
      } else {
        const index = this.selected.indexOf(id)
        if (index > -1) {
          this.selected.splice(index, 1)
        } else {
          this.selected.push(id)
        }
      }
    },
    getTeacherList () {
      this.$apollo
        .mutate({
          mutation: ALL_TEACHERS_QUERY
        })
        .then(response => {
          this.teachers = response.data.getTeachersList.users
          this.getLocationsList()
        })
    },
    getLocationsList () {
      this.$apollo
        .mutate({
          mutation: ALL_LOCATIONS
        })
        .then(response => {
          this.locations = response.data.locations
        })
    },
    setSelected (value) {
      this.custom_search_filter = value
    },
    statusSelected (value) {
      this.custom_search_filter_status = value
    },

    updateStatus (id, status) {
      this.$apollo
        .mutate({
          mutation: UPDATE_USER_STATUS,
          variables: {
            id,
            status
          }
        }).then(response => {
          if (response) {
            this.$vs.notify({
              title: 'Teacher',
              text: 'Status Updated Sucessfully',
              color: 'success',
              position: 'top-right'
            })

          }
        })
    },
    updateEmailStatus (id, email_confirmed) {
      this.$apollo
        .mutate({
          mutation: UPDATE_MANAGER_EMAIL_STATUS,
          variables: {
            id,
            email_confirmed
          }
        }).then(response => {
          if (response) {
            this.$vs.notify({
              title: 'Email Status',
              text: 'Updated Sucessfully',
              color: 'success',
              position: 'top-right'
            })
          }
        })
    },
    togglePassswordSidebar (val = false) {
      this.addPasswordSidebar = val
      if (!val) {
        this.getTeacherList()
      }
    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)

    },
    confirmDeleteRecord (teacher) {
      this.DeletedItem = teacher
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to permanently delete "${teacher.fname} ${teacher.lname}"`,
        accept: this.deleteData,
        acceptText: 'Delete'
      })
    },
    deleteData () {
      this.$apollo
        .mutate({
          mutation: REMOVE_MANAGER,
          variables: {
            id: this.DeletedItem.id
          }
        }).then(response => {
          this.getTeacherList()
          if (response.data.deleteManager.status == 'Success') {
            this.StatusSuccess('Deleted Successfully', response.data.deleteManager.color)
          } else {
            this.StatusSuccess('Failed to Delete', response.data.deleteManager.color)
          }
        }).catch(error => {
          console.log(error)
        })
      // this.$store.dispatch('dataList/removeManager', id).catch(err => {
      //   console.error(err)
      // })
    },
    editData (data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    passwordData (data) {
      this.passwordSidebarData = data
      this.togglePassswordSidebar(true)
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
      if (!val) {
        this.getTeacherList()
      }
    },
    setitemsPerPage (number) {
      this.itemsPerPage = number
      localStorage.setItem('itemsPerPage', number)
    }
  },
  created () {
    if (localStorage.getItem('itemsPerPage')) {
      this.itemsPerPage = localStorage.getItem('itemsPerPage')
    }
    this.getTeacherList()
    

  },
  mounted () {
    this.isMounted = true
  }

}
</script>

<style lang="scss">
#data-list-list-view {
  .user_add_btn{
    float: right ;
    margin-top: -50px
  }
  @media (max-width: 461px) {
    .user_add_btn {
      margin-top: 60px
    }
  }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
    .user-img {
      height: 50px;
      border-radius: 50%;
    }
  [data-letterstudent]:before {
  content:attr(data-letterstudent);
  }
  .image-not-found{
  display:inline-block;
  font-size:35px;
  width:50px;
  height:50px;
  text-align:center;
  border-radius:50%;
  vertical-align:middle;
  margin-right:1em;
  }
  }
}
</style>
